import * as React from 'react';
import BenefitThumbnail from './images/benefit-thumbnail.png';
import BenefitThumbnailSp from './images/benefit-thumbnail-sp.png';
import { Header } from './base';
import './benefitSection.module.scss';
import { observer } from 'mobx-react';
import { GlobalStatesV3 } from '../../../../commonv3/states/GlobalStatesV3';

export const BenefitSection = observer(() => (
    <div styleName="section">
        <Header>お持ちのチケットを使って無料で移行をお願いします</Header>
        <div styleName="thumbnail-wrapper">
            <img src={GlobalStatesV3.viewport.isMobile ? BenefitThumbnailSp : BenefitThumbnail} styleName="thumbnail" />
        </div>
        <div styleName="text">
            既存会員さまなら新しいSHEをお得にご利用できます。お持ちのチケット2枚で1ヶ月分の料金を無料にすることができます。 (例えば、10チケットお持ちの方は5ヶ月分無料で利用できます)
            全コースオンラインでの受け放題、グループコーチングなど新しいSHElikesのサービスを今すぐご利用しませんか？<br />
            <br />
            ※枚数が奇数の場合は繰り上げて適用します<br />
            ※無料期間がすぎると自動的に料金が発生します。ご注意ください。<br />
            ※応用コースは9/1迄に順次リリース予定です。それまでは基礎コースのみご利用できます
        </div>
    </div>
));
